import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import LinearProgress from "@material-ui/core/LinearProgress";
import { connect } from "react-redux";
import Axios from "axios";
import jwtDecode from "jwt-decode";

import { url } from "../../../../config/config";
import { login } from "../../../../redux/action/action";
import { withRouter } from "react-router-dom";
import { useStyles } from "./EditForm.css";
import FormLoader from "../../../../Component/FormLoader/FormLoader";

const CustomLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

class CustomerEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        profileImageUrl: "",
        firstName: "",
        lastName: "",
        username: "",
        email: "",
      },
      firstNameError: "",
      lastNameError: "",
      usernameError: "",
      userId: "",
      percentage: 0,
      success: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.decodeToken();
  }

  decodeToken = async () => {
    try {
      let userData = await jwtDecode(this.props.userToken);
      const response = await Axios.get(`${url}/api/users/${userData._id}`, {
        headers: {
          "x-auth-token": this.props.userToken,
        },
      });
      if (response.data) {
        this.setState({
          data: {
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            username: userData.username,
            profileImageUrl: response.data.imageUrl,
          },
          userId: userData._id,
          isEmpty: true,
          fileSize: 0,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleUpload = (e) => {
    let reader = new FileReader();
    this.setState({
      data: { ...this.state.data, profileImage: e.target.files[0] },
    });
    let files = e.target.files[0];
    reader.onload = (e) => {
      this.setState({
        data: {
          ...this.state.data,
          profileImageUrl: e.target.result,
        },
      });
    };

    reader.onprogress = (data) => {
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: progress,
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleProgress = () =>
    this.state.percentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.percentage}
          variant="determinate"
        />
        {this.state.percentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.percentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  checkError = () => {
    let firstNameError = "";
    let lastNameError = "";
    let usernameError = "";

    if (this.state.data.firstName.length < 3) {
      firstNameError = "First Name must be minimum of 3 characters";
    }
    if (this.state.data.lastName.length < 3) {
      lastNameError = "Last Name must be minimum of 3 characters";
    }
    if (this.state.data.username.length < 4) {
      usernameError = "Password must be minimum of 4 characters";
    }

    if (firstNameError || lastNameError || usernameError) {
      this.setState({
        firstNameError,
        lastNameError,
        usernameError,
      });
      return true;
    } else {
      this.setState({
        firstNameError: "",
        lastNameError: "",
        usernameError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();

    if (errorStatus === false) {
      this.setState({ loading: true });
      let data = {
        firstName: this.state.data.firstName,
        lastName: this.state.data.lastName,
        username: this.state.data.username,
        imageUrl: this.state.data.profileImageUrl,
      };
      const response = await Axios.put(
        `${url}/api/users/${this.state.userId}`,
        data,
        {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        }
      );
      if (response.data.msg) {
        console.log(response.data.msg);
        this.setState({ loading: false });
      } else {
        if (response.data.token) {
          this.setState({ success: "Changed Successfully" });
          this.props.login(response.data.token);
          this.props.history.push("/profile");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper style={{ padding: 20 }}>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>
          Edit Your Profile
        </div>
        <div className={classes.root}>
          <div className={classes.editFormStyle}>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Avatar style={{ width: 200, height: 200 }}>
                  <img
                    src={this.state.data.profileImageUrl}
                    alt="Profile"
                    style={{ width: 200, height: 200 }}
                  />
                </Avatar>
              </div>
              <div
                style={{
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  id="imageUpload"
                  style={{ display: "none" }}
                  onChange={this.handleUpload}
                />
                <div>{this.handleProgress()}</div>
                <label htmlFor="imageUpload">
                  <Button
                    variant="outlined"
                    className={classes.buttonStyle}
                    component="span"
                  >
                    Upload or edit image
                  </Button>
                </label>
              </div>
            </div>
            <br />
            <Divider />
            <form onSubmit={this.handleSubmit}>
              <TextField
                name="firstName"
                label="First Name"
                type="text"
                required
                margin="normal"
                variant="outlined"
                className={classes.inputWithoutMargin}
                style={{ marginRight: 10 }}
                error={this.state.firstNameError ? true : false}
                helperText={this.state.firstNameError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.firstName || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="lastName"
                label="Last Name"
                type="text"
                required
                margin="normal"
                variant="outlined"
                className={classes.inputWithoutMargin}
                error={this.state.lastNameError ? true : false}
                helperText={this.state.lastNameError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.lastName || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="username"
                label="Username"
                type="string"
                fullWidth
                required
                margin="normal"
                variant="outlined"
                error={this.state.usernameError ? true : false}
                helperText={this.state.usernameError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.username || ""}
                onChange={this.handleChange}
              />

              <TextField
                name="email"
                label="Email"
                type="email"
                fullWidth
                disabled
                margin="normal"
                variant="outlined"
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.email || ""}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  className={classes.buttonStyle}
                >
                  Modify
                </Button>
                {this.state.loading && <FormLoader />}
              </div>
            </form>
            <br />
          </div>
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (userToken) => {
      dispatch(login(userToken));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(CustomerEditForm)));
